import type { ReduxAction, ScrollPositionState } from '@repo/utils/types';
import { Map } from 'immutable';

export function scrollPositionReducer(
  state: ScrollPositionState = Map(),
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'SAVE_SCROLL_POSITION':
      return state.set(payload.viewID, payload.scrollPosition);

    default:
      return state;
  }
}
